import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material';

import { CodeTable } from '../../../../core/model/v2/code-table';
import { Patient } from '../../../../core/models/patient/patient';
import {
  PatientEmergencyContactInfo,
} from '../../../../core/models/patient/patientEmergencyContactInfo';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-emergency-contact-edit',
  templateUrl: './patient-emergency-contact-edit.component.html',
  styleUrls: ['./patient-emergency-contact-edit.component.scss']
})
export class PatientEmergencyContactEditComponent implements OnInit {
  @Input() emergencyContact: PatientEmergencyContactInfo;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEvent = new EventEmitter();
  relationshipCodes: CodeTable;
  userId: number;
  contactError: string = null;
  nameError: string = null;
  relationError: string = null;
  //patientProfile: Patient;
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private loaderService: WindowLoaderService, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<PatientEmergencyContactEditComponent>) { }

  ngOnInit() {
    if (this.data.isEditMode) {
      this.emergencyContact = this.data.emergencyContactInfo;
    } else {
      this.emergencyContact = new PatientEmergencyContactInfo();
      this.emergencyContact.patientId = this.data.patientId;
    }
    this.userService.getUserDetails().subscribe(
      (res) => {
        this.userId = res.id;
      },
      (error) => { console.error(error); });

    this.loadCodes();
  }

  cancel() {
    this.dialogRef.close();
    //this.toggleEvent.emit();
  }

  loadCodes() {
    this.relationshipCodes = this.commonService.getItemCodesFiltered('EMERGENCYRELATION');
  }
  updateEmergencyContact() {
    this.contactError = null;
    this.nameError = null;
    this.relationError = null;

    if (this.emergencyContact) {
      if (!this.emergencyContact.emergencyContactName) {
        this.nameError = 'Contact Name is required';
        return;
      }
      if (!this.emergencyContact.relationship) {
        this.relationError = 'Relation to Self is required';
        return;
      }
      if (!this.emergencyContact.contactNumber) {
        this.contactError = 'Contact Phone Number is required';
        return;
      }
      if (this.emergencyContact.contactNumber && this.emergencyContact.contactNumber.length < 10) {
        this.contactError = 'Enter valid Contact Phone Number';
        return;
      }
      this.emergencyContact.patientId = this.patientProfile && this.patientProfile.id ? this.patientProfile.id : this.emergencyContact.patientId;
      if (this.emergencyContact.patientId === undefined) {
        this.emergencyContact.patientId = 0;
      }
      this.loaderService.blockWithLoader(this.patientService.updatePatientEmergencyContactInfo(this.emergencyContact)).subscribe(
        (res) => {
          if (res.isSuccess) {

            this.dialogRef.close();
            //this.patientProfileChange.emit(this.patientProfile);
          } else
            console.error(res);
        },
        (error) => {
          console.error(error);
        }
      );

    }
  }
}
